import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "sonner";
import {
  GraphQLClient,
  GraphQLErrorMessage,
} from "../../../../../shared/gql-client";
import i18next from "i18next";
import PackingListService from "../service/packingListService";
import { PackingListModel } from "../../domain/models/packingListModel";

const packingListApi = new PackingListService();

export const getPackingList = createAsyncThunk(
  "planning/get/packingList",
  async ({ date, type }: { date: string; type: string }, thunkAPI) => {
    const { client } = thunkAPI.extra as { client: GraphQLClient };
    try {
      packingListApi.setClient(client);
      return await packingListApi.queryPackingList(date, type);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const getExportPackingList = createAsyncThunk(
  "planning/get/exportpackingList",
  async ({ date, type }: { date: string; type: string }, thunkAPI) => {
    const { client } = thunkAPI.extra as { client: GraphQLClient };
    try {
      packingListApi.setClient(client);
      return await packingListApi.exportPackingList(date, type);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export interface PackingListSliceModel {
  loading: boolean;
  packingList: PackingListModel | null;
  date: string;
  type: string;
}

const initialState = {
  loading: true,
  packingList: null,
  date: new Date().toISOString().split("T")[0],
  type: "DeliverTake",
} as PackingListSliceModel;

const packingListSlice = createSlice({
  name: "packingList",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setPackingListDate: (state, action) => {
      state.date = action.payload;
    },
    setPackingListType: (state, action) => {
      state.type = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPackingList.fulfilled, (state, action) => {
      state.packingList = action.payload;
      state.loading = false;
    });
    builder.addCase(getPackingList.pending, (state) => {
      state.loading = true;
    });
    builder.addMatcher(
      (action) => [getPackingList.rejected.type].includes(action.type),
      (state, action: { payload: GraphQLErrorMessage }) => {
        state.loading = false;
        console.error(action.payload);
        toast.error(i18next?.t("common:" + action.payload.message));
      },
    );
  },
});

export const { setLoading, setPackingListDate, setPackingListType } =
  packingListSlice.actions;

export default packingListSlice.reducer;
